const MOBILE_VIDEO_FALLBACK_PROFILE = {
  profile_id: "generic_mobile_video",
  event_type: "generic",
  style_family: "generic",
  format: "mobile_video",
  scene_count: 5,
  style_direction: {
    style_prompt:
      "Create a polished mobile video invitation with a strong opening, clear details, and a warm closing.",
    mood: ["polished", "inviting", "modern"],
    copy_tone: "warm, clear, inviting",
    typography_direction: "Expressive heading typography with highly readable details.",
    ornament_density: "balanced",
    readability_priority: "high",
  },
  palette: {
    primary: "#8A1738",
    secondary: "#D4AF37",
    accent: "#FFB84D",
    background: "#2D0817",
    text: "#FFF2D4",
    panel: "#FFF8EC",
    notes: "Use a high-contrast palette with readable text on mobile.",
  },
  scene_briefs: [
    {
      scene_id: "opening",
      scene_name: "Opening",
      purpose: "Create the first impression and introduce the event.",
      duration_seconds: 4.5,
      visual_direction: "Strong visual opening with clear event title and a decorative background.",
      copy_slots: {
        invitation_line: "You are invited",
        event_title: "Event Celebration",
      },
      asset_roles: ["opening_background", "hero_visual", "decorative_overlay"],
      asset_usage_notes: "Keep title text editable and do not bake text into assets.",
      animation_direction: "Background holds steady, hero visual reveals gently, and title text fades in.",
      element_motions: [
        {
          target_role: "hero_visual",
          preset: "scale_in",
          start_time_seconds: 0.5,
          duration_seconds: 1,
          hold_after_motion: true,
        },
        {
          target_role: "opening_text",
          preset: "staggered_text_reveal",
          start_time_seconds: 1.4,
          duration_seconds: 1.4,
          hold_after_motion: true,
        },
      ],
      transition_direction: "Soft crossfade into details.",
      readability_level: "medium",
      must_include: ["event title", "invitation line"],
      must_avoid: ["text baked into background", "busy unreadable opening"],
    },
    {
      scene_id: "details",
      scene_name: "Event Details",
      purpose: "Communicate date, time, and important details clearly.",
      duration_seconds: 5,
      visual_direction: "Readable panel over a calm background with minimal decorative accents.",
      copy_slots: {
        details_title: "Details",
        event_date: "Event Date",
        event_time: "Event Time",
      },
      asset_roles: ["detail_background", "readable_panel", "small_icon"],
      asset_usage_notes: "Prioritize readable details over decoration.",
      animation_direction: "Panel fades in and detail lines reveal one by one.",
      element_motions: [
        {
          target_role: "details_text",
          preset: "staggered_text_reveal",
          start_time_seconds: 0.7,
          duration_seconds: 2.4,
          hold_after_motion: true,
        },
      ],
      transition_direction: "Fade into venue scene.",
      readability_level: "high",
      must_include: ["date", "time"],
      must_avoid: ["low contrast", "too much motion behind text"],
    },
    {
      scene_id: "venue",
      scene_name: "Venue",
      purpose: "Show venue and address information.",
      duration_seconds: 4.5,
      visual_direction: "Clean venue card with supportive decorative accents.",
      copy_slots: {
        venue_title: "Venue",
        venue_name: "Venue Name",
        venue_address: "Venue Address",
      },
      asset_roles: ["venue_background", "venue_card", "side_accent"],
      asset_usage_notes: "Keep address text large enough for mobile.",
      animation_direction: "Venue card fades in and venue lines reveal slowly.",
      element_motions: [
        {
          target_role: "venue_text",
          preset: "staggered_text_reveal",
          start_time_seconds: 0.7,
          duration_seconds: 2,
          hold_after_motion: true,
        },
      ],
      transition_direction: "Fade into RSVP scene.",
      readability_level: "high",
      must_include: ["venue name", "venue address"],
      must_avoid: ["small address text"],
    },
    {
      scene_id: "rsvp",
      scene_name: "RSVP",
      purpose: "Show RSVP or contact details.",
      duration_seconds: 4,
      visual_direction: "Simple closing information card with warm decorative accents.",
      copy_slots: {
        rsvp_label: "RSVP",
        rsvp_contact: "RSVP / Contact",
      },
      asset_roles: ["rsvp_background", "rsvp_card", "decorative_accent"],
      asset_usage_notes: "Use decoration sparingly so RSVP stays readable.",
      animation_direction: "RSVP label and contact fade up.",
      element_motions: [
        {
          target_role: "rsvp_text",
          preset: "fade_up",
          start_time_seconds: 0.6,
          duration_seconds: 1.3,
          hold_after_motion: true,
        },
      ],
      transition_direction: "Warm fade into closing.",
      readability_level: "high",
      must_include: ["RSVP contact"],
      must_avoid: ["decor covering contact details"],
    },
    {
      scene_id: "closing",
      scene_name: "Closing",
      purpose: "End with a warm message and emotional hold.",
      duration_seconds: 4,
      visual_direction: "Warm final scene with the event mood reinforced.",
      copy_slots: {
        closing_message: "We look forward to celebrating with you",
      },
      asset_roles: ["closing_background", "closing_visual", "soft_overlay"],
      asset_usage_notes: "Keep final message editable.",
      animation_direction: "Final message fades in and holds.",
      element_motions: [
        {
          target_role: "closing_text",
          preset: "fade_in",
          start_time_seconds: 0.8,
          duration_seconds: 1.4,
          hold_after_motion: true,
        },
      ],
      transition_direction: "Fade out.",
      readability_level: "medium",
      must_include: ["closing message"],
      must_avoid: ["abrupt ending"],
    },
  ],
  asset_plan: {
    mode: "mixed",
    assets: [],
  },
  motion_plan: {
    global_motion_style: "cinematic",
    scene_transitions: [
      { from_scene_id: "opening", to_scene_id: "details", preset: "crossfade", duration_seconds: 0.5 },
      { from_scene_id: "details", to_scene_id: "venue", preset: "fade", duration_seconds: 0.4 },
      { from_scene_id: "venue", to_scene_id: "rsvp", preset: "fade", duration_seconds: 0.4 },
      { from_scene_id: "rsvp", to_scene_id: "closing", preset: "fade", duration_seconds: 0.5 },
    ],
    timing_notes: "Opening and closing can be richer; details should stay readable.",
    polotno_animation_target: "native_polotno_2_8",
  },
  generation_options: {
    generate_plan: true,
    generate_missing_asset_briefs: true,
    generate_missing_assets: false,
    generate_polotno_draft: true,
    open_in_polotno_after_generation: true,
  },
};

const CULTURAL_PROGRAMS_PROFILE = {
  profile_id: "cultural_programs_mobile_video",
  event_type: "cultural_programs",
  format: "mobile_video",
  scene_briefs: [
    { scene_id: "festival_opening", scene_name: "Festival / Program Opening" },
    { scene_id: "host_organizer", scene_name: "Host / Organizer" },
    { scene_id: "program_details", scene_name: "Program Details" },
    { scene_id: "venue", scene_name: "Venue" },
    { scene_id: "closing", scene_name: "Closing Blessing / CTA" },
  ],
};

const DEVOTIONAL_FESTIVE_PROFILE = {
  profile_id: "devotional_festive_mobile_video",
  style_family: "devotional_festive",
  format: "mobile_video",
  style_direction: {
    mood: ["devotional", "auspicious", "festive", "warm"],
    copy_tone: "warm, respectful, inviting",
    typography_direction: "Graceful devotional headings with highly readable detail text.",
    ornament_density: "rich",
    readability_priority: "high",
  },
  palette: {
    primary: "#C2410C",
    secondary: "#F59E0B",
    accent: "#D4AF37",
    background: "#4A1208",
    text: "#FFF7D6",
    panel: "#FFF3D1",
    notes: "Use saffron, vermillion, marigold yellow, antique gold, ivory, and warm diya glow.",
  },
};

const GANESH_CHATURTHI_PROFILE = {
  profile_id: "ganesh_chaturthi_devotional_festive_mobile_video",
  event_type: "cultural_programs",
  subevent_type: "ganesh_chaturthi",
  style_family: "devotional_festive",
  format: "mobile_video",
  scene_count: 5,
  style_direction: {
    style_prompt:
      "Create a premium Ganesh Chaturthi mobile video invitation with warm devotional saffron-gold styling, separate animated marigold garlands, Ganesha appearing from center, and flowers moving toward Ganesha's feet as an offering.",
    style_preset_id: "devotional_saffron_gold",
    mood: ["devotional", "auspicious", "festive", "warm", "premium"],
    copy_tone: "warm, respectful, inviting",
    typography_direction: "Elegant Indian festive headings with highly readable detail text.",
    ornament_density: "rich",
    readability_priority: "high",
  },
  scene_briefs: [
    {
      scene_id: "opening_blessing",
      scene_name: "Auspicious Opening",
      purpose: "Create a devotional first impression and reveal the Ganesh Chaturthi invitation theme.",
      duration_seconds: 5,
      visual_direction:
        "Static saffron-gold stage background, Ganesha artwork centered, marigold garland at top, diya glow near bottom, flowers entering from both sides toward Ganesha's feet.",
      copy_slots: {
        devotional_kicker: "Shree Ganeshaya Namah",
        invitation_line: "You are warmly invited",
        festival_title: "Ganesh Chaturthi Celebration",
        opening_blessing: "Ganpati Bappa Morya",
      },
      asset_roles: [
        "static_stage_background",
        "ganesha_center_artwork",
        "ganesha_halo_glow",
        "marigold_top_garland",
        "diya_glow_overlay",
        "flower_offering_left",
        "flower_offering_right",
      ],
      asset_usage_notes:
        "Do not bake Ganesha, flowers, garlands, diya, or text into the background. They must be separate Polotno elements.",
      animation_direction:
        "Background is static. Marigold garland slides from top. Ganesha fades and scales in from center. Flowers move from left and right toward Ganesha's feet and stay there. Text reveals in a staggered devotional sequence.",
      element_motions: [
        { target_role: "marigold_top_garland", preset: "slide_from_top", start_time_seconds: 0.2, duration_seconds: 1, hold_after_motion: true },
        { target_role: "ganesha_center_artwork", preset: "scale_in", start_time_seconds: 0.7, duration_seconds: 1.3, hold_after_motion: true },
        { target_role: "flower_offering_left", preset: "move_from_left_to_target", start_time_seconds: 1.4, duration_seconds: 1.4, hold_after_motion: true },
        { target_role: "flower_offering_right", preset: "move_from_right_to_target", start_time_seconds: 1.4, duration_seconds: 1.4, hold_after_motion: true },
        { target_role: "opening_text", preset: "staggered_text_reveal", start_time_seconds: 2.2, duration_seconds: 1.8, hold_after_motion: true },
      ],
      transition_direction: "Warm crossfade into host scene.",
      readability_level: "medium",
      must_include: ["Ganesha center reveal", "moving marigold garland", "flower offering movement"],
      must_avoid: ["text baked into images", "Ganesha inside background", "flowers inside background"],
    },
    {
      scene_id: "host_invitation",
      scene_name: "Host Invitation",
      purpose: "Introduce who is inviting guests and the nature of the celebration.",
      duration_seconds: 4.5,
      visual_direction:
        "Warm detail background with readable ivory panel, subtle Ganesha watermark, lotus divider, and soft marigold corner accents.",
      copy_slots: {
        hosted_by: "Hosted by",
        host_name: "Host / Family / Mandal Name",
        occasion_note: "Join us for puja, aarti, prasad, and celebration",
      },
      asset_roles: ["detail_background", "readable_panel", "subtle_ganesha_watermark", "lotus_divider"],
      asset_usage_notes: "Use a calmer background than the opening so host copy is easy to read.",
      animation_direction:
        "Panel softly fades in. Host label fades up. Host name scales in slightly. Divider fades in after host name. Supporting copy fades up line by line.",
      element_motions: [
        { target_role: "readable_panel", preset: "fade_in", start_time_seconds: 0.1, duration_seconds: 0.8, hold_after_motion: true },
        { target_role: "host_text", preset: "fade_up", start_time_seconds: 0.8, duration_seconds: 1.4, hold_after_motion: true },
      ],
      transition_direction: "Fade into details scene.",
      readability_level: "high",
      must_include: ["host name", "occasion note"],
      must_avoid: ["busy background behind host name"],
    },
    {
      scene_id: "puja_program_details",
      scene_name: "Puja and Program Details",
      purpose: "Clearly communicate date, time, puja/aarti details, prasad, and program highlights.",
      duration_seconds: 5,
      visual_direction:
        "Clean readable detail card over calm festive background, small diya/bell/modak accents only.",
      copy_slots: {
        details_title: "Puja & Program Details",
        event_date: "Event Date",
        puja_time: "Aarti / Puja Time",
        program_highlights: "Puja\nAarti\nPrasad\nCelebration",
        prasad_note: "Prasad will be served",
      },
      asset_roles: ["detail_background", "readable_details_card", "small_diya_icon", "temple_bell_icon", "modak_icon"],
      asset_usage_notes: "Motion should be minimal because this scene is information-heavy.",
      animation_direction:
        "Details card fades in first. Title appears. Detail lines reveal one by one with soft fade-up. Decorative icons gently pop in after text.",
      element_motions: [
        { target_role: "readable_details_card", preset: "fade_in", start_time_seconds: 0.1, duration_seconds: 0.7, hold_after_motion: true },
        { target_role: "details_text", preset: "staggered_text_reveal", start_time_seconds: 0.8, duration_seconds: 2.8, hold_after_motion: true },
      ],
      transition_direction: "Fade into venue scene.",
      readability_level: "high",
      must_include: ["date", "puja time", "program highlights"],
      must_avoid: ["large moving assets behind text", "low contrast text"],
    },
    {
      scene_id: "venue_rsvp",
      scene_name: "Venue and RSVP",
      purpose: "Clearly communicate venue, address, and RSVP contact.",
      duration_seconds: 4.5,
      visual_direction:
        "Warm festive venue scene with readable panel, marigold side accents, soft diya glow, and optional rangoli floor accent.",
      copy_slots: {
        venue_title: "Venue",
        venue_name: "Venue Name",
        venue_address: "Venue Address",
        rsvp_contact: "RSVP / Contact",
      },
      asset_roles: ["venue_background", "venue_details_card", "marigold_side_accents", "diya_glow_overlay", "rangoli_floor_accent"],
      asset_usage_notes: "Keep venue/address text very readable on mobile.",
      animation_direction:
        "Panel fades in. Marigold side accents slide in slightly from sides. Venue title fades in. Venue details reveal line by line. RSVP appears last.",
      element_motions: [
        { target_role: "venue_text", preset: "staggered_text_reveal", start_time_seconds: 0.8, duration_seconds: 2, hold_after_motion: true },
      ],
      transition_direction: "Warm fade into closing scene.",
      readability_level: "high",
      must_include: ["venue name", "venue address", "RSVP contact"],
      must_avoid: ["small address text", "decor covering text"],
    },
    {
      scene_id: "closing_blessing",
      scene_name: "Closing Blessing",
      purpose: "End emotionally with blessing and devotional hold.",
      duration_seconds: 5,
      visual_direction:
        "Warm glowing background, Ganesha artwork centered, flowers settled at feet, soft diya glow and final blessing text.",
      copy_slots: {
        closing_message: "We look forward to celebrating with you",
        closing_blessing: "Ganpati Bappa Morya",
      },
      asset_roles: ["closing_background", "ganesha_center_artwork", "flower_offering_settled", "diya_glow_overlay", "soft_particle_overlay"],
      asset_usage_notes: "Reuse the Ganesha and flower offering assets from the opening where possible.",
      animation_direction:
        "Ganesha gently holds at center or softly appears again. Flowers remain settled near feet. Diya glow softly pulses. Final blessing text fades in slowly.",
      element_motions: [
        { target_role: "diya_glow_overlay", preset: "soft_pulse", start_time_seconds: 0, duration_seconds: 5, hold_after_motion: true },
        { target_role: "closing_text", preset: "fade_in", start_time_seconds: 1, duration_seconds: 1.6, hold_after_motion: true },
      ],
      transition_direction: "Fade to warm gold.",
      readability_level: "medium",
      must_include: ["closing blessing", "settled flowers at Ganesha's feet"],
      must_avoid: ["abrupt ending"],
    },
  ],
  asset_plan: {
    mode: "mixed",
    assets: [
      {
        asset_key: "static_stage_background",
        role: "static_stage_background",
        purpose: "Full-screen opening background only, with no movable objects baked in.",
        source_strategy: "generate_new_asset",
        target_scenes: ["opening_blessing"],
        prompt:
          "Create ONE vertical Ganesh Chaturthi static stage background for a 1080x1920 mobile video canvas. This asset must be background only: saffron, vermillion, antique gold, and warm ivory textures, soft devotional ambient lighting, subtle vignette depth, and empty safe space for overlaid editable text and separate animated decorative layers. Do not include any foreground objects, deity artwork, flowers, garlands, diya lamps, rangoli, particles, or text.",
        negative_prompt:
          "Ganesha, Ganpati, deity, idol, statue, silhouette, face, trunk, mouse, diya, lamp, flame, marigold, garland, flower, rangoli, particles, sparkles, bell, kalash, foreground object, text, typography, letters, words, watermark, logo",
        transparent_background_required: false,
        aspect_ratio: "9:16",
        intended_width: 1080,
        intended_height: 1920,
        usage_mode: "place_directly",
      },
      {
        asset_key: "ganesha_center_artwork",
        role: "ganesha_center_artwork",
        purpose: "Main respectful Ganesha artwork that can reveal from center.",
        source_strategy: "generate_new_asset",
        target_scenes: ["opening_blessing", "closing_blessing"],
        prompt:
          "Create ONE isolated transparent-background Lord Ganesha center artwork cutout asset for a Ganesh Chaturthi Polotno video template. This asset must contain only respectful premium Ganesha artwork, centered and cleanly cropped for reveal animation. Transparent background required with real alpha channel. Do not add scenery, frame, garland, flowers, diya, rangoli, text, poster layout, or background.",
        negative_prompt:
          "background, scenery, poster, full scene, frame, border, garland, marigold, flower, flower offering, diya, lamp, flame, rangoli, title, text, typography, words, letters, watermark, logo, distorted face, extra limbs, low quality",
        transparent_background_required: true,
        aspect_ratio: "asset_native",
        intended_width: null,
        intended_height: null,
        usage_mode: "place_directly",
      },
      {
        asset_key: "marigold_top_garland",
        role: "marigold_top_garland",
        purpose: "Movable garland that slides into the top of the frame.",
        source_strategy: "generate_new_asset",
        target_scenes: ["opening_blessing"],
        prompt:
          "Create ONE isolated transparent-background horizontal marigold top garland cutout asset. This asset must contain only an elegant horizontal garland made of orange and yellow marigold flowers, small green leaves, and subtle gold thread accents. It should be suitable for sliding down from the top edge of a vertical mobile video. Transparent background required with real alpha channel. Do not add white, black, gray, solid, scene, or checkerboard background. No other objects.",
        negative_prompt:
          "Ganesha, Ganpati, deity, idol, statue, silhouette, face, trunk, hands, mouse, flower offering, loose petals, diya, lamp, flame, rangoli, floor, background, white background, black background, gray background, solid background, checkerboard, transparency grid, full scene, poster, invitation, title, text, typography, letters, words, watermark, logo",
        transparent_background_required: true,
        aspect_ratio: "wide_overlay",
        intended_width: null,
        intended_height: null,
        usage_mode: "place_directly",
      },
      {
        asset_key: "flower_offering_left",
        role: "flower_offering_left",
        purpose: "Flower offering cluster that moves from left side toward Ganesha's feet.",
        source_strategy: "generate_new_asset",
        target_scenes: ["opening_blessing", "closing_blessing"],
        prompt:
          "Create ONE isolated transparent-background flower offering cutout asset. This asset must contain only a compact cluster of marigold blossoms, rose petals, and a few lotus-like petals, angled from lower-left toward center for side-entry animation. Tight crop around the flowers. Transparent background required with real alpha channel. Do not add white, black, gray, solid, scene, or checkerboard background. No other objects.",
        negative_prompt:
          "Ganesha, Ganpati, deity, idol, statue, silhouette, face, trunk, hands, mouse, garland, marigold garland, frame, border, diya, lamp, flame, rangoli, floor, background, white background, black background, gray background, solid background, checkerboard, transparency grid, full scene, poster, invitation, title, text, typography, letters, words, watermark, logo",
        transparent_background_required: true,
        aspect_ratio: "asset_native",
        intended_width: null,
        intended_height: null,
        usage_mode: "place_directly",
      },
      {
        asset_key: "flower_offering_right",
        role: "flower_offering_right",
        purpose: "Flower offering cluster that moves from right side toward Ganesha's feet.",
        source_strategy: "generate_new_asset",
        target_scenes: ["opening_blessing", "closing_blessing"],
        prompt:
          "Create ONE isolated transparent-background flower offering cutout asset. This asset must contain only a compact cluster of marigold blossoms, rose petals, and a few lotus-like petals, angled from lower-right toward center for side-entry animation. Tight crop around the flowers. Transparent background required with real alpha channel. Do not add white, black, gray, solid, scene, or checkerboard background. No other objects.",
        negative_prompt:
          "Ganesha, Ganpati, deity, idol, statue, silhouette, face, trunk, hands, mouse, garland, marigold garland, frame, border, diya, lamp, flame, rangoli, floor, background, white background, black background, gray background, solid background, checkerboard, transparency grid, full scene, poster, invitation, title, text, typography, letters, words, watermark, logo",
        transparent_background_required: true,
        aspect_ratio: "asset_native",
        intended_width: null,
        intended_height: null,
        usage_mode: "place_directly",
      },
    ],
  },
  motion_plan: {
    global_motion_style: "cinematic",
    scene_transitions: [
      { from_scene_id: "opening_blessing", to_scene_id: "host_invitation", preset: "crossfade", duration_seconds: 0.5, notes: "Warm devotional crossfade." },
      { from_scene_id: "host_invitation", to_scene_id: "puja_program_details", preset: "fade", duration_seconds: 0.4 },
      { from_scene_id: "puja_program_details", to_scene_id: "venue_rsvp", preset: "fade", duration_seconds: 0.4 },
      { from_scene_id: "venue_rsvp", to_scene_id: "closing_blessing", preset: "fade_to_gold", duration_seconds: 0.6 },
    ],
    timing_notes:
      "Opening has the richest motion. Detail scenes must be slower and more readable. Closing should hold emotionally.",
    polotno_animation_target: "native_polotno_2_8",
  },
  generation_options: {
    generate_plan: true,
    generate_missing_asset_briefs: true,
    generate_missing_assets: true,
    generate_polotno_draft: true,
    open_in_polotno_after_generation: true,
  },
};

const EXACT_PROFILES = {
  "cultural_programs|ganesh_chaturthi|devotional_festive|mobile_video": GANESH_CHATURTHI_PROFILE,
};

const EVENT_TYPE_PROFILES = {
  cultural_programs: CULTURAL_PROGRAMS_PROFILE,
};

const STYLE_FAMILY_PROFILES = {
  devotional_festive: DEVOTIONAL_FESTIVE_PROFILE,
};

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function mergeProfile(base, override) {
  if (!override) return base;

  const next = { ...base, ...override };
  next.style_direction = {
    ...(base.style_direction || {}),
    ...(override.style_direction || {}),
  };
  next.palette = {
    ...(base.palette || {}),
    ...(override.palette || {}),
  };
  next.asset_plan = {
    ...(base.asset_plan || {}),
    ...(override.asset_plan || {}),
  };
  next.motion_plan = {
    ...(base.motion_plan || {}),
    ...(override.motion_plan || {}),
  };
  next.generation_options = {
    ...(base.generation_options || {}),
    ...(override.generation_options || {}),
  };

  if (override.scene_briefs) next.scene_briefs = override.scene_briefs;
  if (override.asset_plan?.assets) {
    next.asset_plan.assets = override.asset_plan.assets;
  }
  if (override.motion_plan?.scene_transitions) {
    next.motion_plan.scene_transitions = override.motion_plan.scene_transitions;
  }

  return next;
}

function profileKey({ eventType, subeventType, styleFamily, format }) {
  return [eventType, subeventType, styleFamily, format].map((value) => value || "").join("|");
}

export function getAdminAiTemplateDefaults({
  templateName = "",
  eventType = "",
  subeventType = "",
  styleFamily = "",
  format = "mobile_video",
} = {}) {
  const normalized = {
    eventType: eventType || "generic",
    subeventType: subeventType || "",
    styleFamily: styleFamily || "generic",
    format: format || "mobile_video",
  };
  const exactProfile = EXACT_PROFILES[profileKey(normalized)];
  const sources = ["generic_mobile_video"];
  let brief = clone(MOBILE_VIDEO_FALLBACK_PROFILE);

  if (EVENT_TYPE_PROFILES[normalized.eventType]) {
    brief = mergeProfile(brief, clone(EVENT_TYPE_PROFILES[normalized.eventType]));
    sources.push(normalized.eventType);
  }

  if (STYLE_FAMILY_PROFILES[normalized.styleFamily]) {
    brief = mergeProfile(brief, clone(STYLE_FAMILY_PROFILES[normalized.styleFamily]));
    sources.push(normalized.styleFamily);
  }

  if (exactProfile) {
    brief = mergeProfile(brief, clone(exactProfile));
    sources.push(exactProfile.profile_id);
  }

  brief.template_name = templateName || brief.template_name || "";
  brief.event_type = normalized.eventType;
  brief.subevent_type = normalized.subeventType || brief.subevent_type || "";
  brief.style_family = normalized.styleFamily;
  brief.format = normalized.format;

  return {
    brief,
    sources,
    warnings: exactProfile
      ? []
      : [`Using generic defaults because no exact profile exists for ${profileKey(normalized)}.`],
  };
}

export function summarizeV2Brief(brief) {
  return {
    sceneCount: brief?.scene_briefs?.length || 0,
    assetCount: brief?.asset_plan?.assets?.length || 0,
    motionTarget: brief?.motion_plan?.polotno_animation_target || "intent_only",
    generationMode: brief?.asset_plan?.mode || "mixed",
  };
}
